/**
 * Standardized field names for requisition form PDFs
 * 
 * These constants define the field names that should be used in PDF forms
 * to ensure consistent mapping between application data and form fields.
 */

export const REQUISITION_FORM_FIELDS = {
  // Customer information
  CUSTOMER_NAME: 'name',
  CUSTOMER_BIRTH_DATE: 'gebdat',
  CUSTOMER_GENDER: 'geschlecht',
  CUSTOMER_GENDER_MALE: 'geschlecht_m',
  CUSTOMER_GENDER_FEMALE: 'geschlecht_w',
  CUSTOMER_GENDER_DIVERSE: 'geschlecht_d',
  CUSTOMER_NUMBER: 'kundennummer',
  CUSTOMER_ID_NUMBER: 'ausweis',
  
  // Collection information
  COLLECTION_DATE: 'datum',
  COLLECTION_TIME: 'zeit',
  
  // Urine sample checkboxes
  URINE_DRUGS: 'urin_drogen',
  URINE_ALCOHOL: 'urin_alk',
  URINE_MEDICATION: 'urin_med',
  URINE_OPIATES: 'urin_opi',
  
  // Hair sample checkboxes
  HAIR_DRUGS: 'haar_drogen',
  HAIR_ALCOHOL: 'haar_alk',
  HAIR_MEDICATION: 'haar_med',
  HAIR_OPIATES: 'haar_opi',
  
  // Blood sample checkboxes
  BLOOD_ALCOHOL: 'blut_alk',
  
  // Hair details
  HAIR_COLOR: 'haarfarbe',
  HAIR_LENGTH: 'haarlänge',
  HAIR_REMAINING_LENGTH: 'restlänge',
  
  // Extraction site
  EXTRACTION_SITE_HEAD: 'entnahme_kopf',
  EXTRACTION_SITE_OTHER: 'entnahme_andere',
  EXTRACTION_SITE_DETAILS: 'entnahme_detail',
  
  // Cosmetic treatment
  COSMETIC_TREATMENT_NONE: 'kosmetik_nein',
  COSMETIC_TREATMENT_YES: 'kosmetik_ja',
  COSMETIC_TREATMENT_DETAILS: 'kosmetik_detail',
  
  // Sample properties
  TEMPERATURE: 'temperatur',
  PH_VALUE: 'ph_wert',
  
  // Order information
  INTERNAL_ORDER_NUMBER: 'auftragsnummer_intern',
  EXTERNAL_ORDER_NUMBER: 'auftragsnummer_extern'
};
